import {
  getData,
  postData,
  getFileData,
  convertPageModel,
  getDataCache
} from './api-base.service'
import {
  baseUrl
} from '../config/env'
import {
  getStore
} from '../config/mUtils'
export const sendSMS = (phone, type = 1) => {
  let data = {
    Phone: phone,
    SMSType: type
  };
  let result = postData('/SMS/SendSMS', data, false);
  return result;
}

export const getBonusPointMechanismByType = (type) => {
  let data = {
    type: type
  };

  let fetchResult = getData('/Common/GetBonusPointMechanismByType', data);

  return fetchResult;
}

export const getWeChatConfig = () => {
  var result = getData('/Common/GetWeChatConfig');
  return result;
}

export const getFileContainerList = () => {
  return getData("/Common/GetFileContainerList");
}

export const saveClientSideError = (action, message) => {
  let data = {
    Action: action,
    Message: message
  };

  return postData("/Common/SaveClientSideError", data);
}




// WEBPACK FOOTER //
// ./src/service/common.service.js